import * as PropTypes from "prop-types";
import * as React from "react";
import { Bling as GPT } from "react-gpt";
import * as Waypoint from "react-waypoint";
import { adBannerSmall, adMobileRectangle, adMobileSquare, adPositions, adSuperzone, adUnits, generateAdTargeting, } from "../../../../shared/utils/ads";
import getResultCategory from "../../utils/getResultCategory";
import removeHTML from "../../utils/removeHTML";
import { AdLabel } from "../ad/adLabel";
import ListItem from "../listItem";
import * as styles from "./styles.css";
export var cleanTitle = function (title) { return title.replace(/\s-\sLonely\sPlanet/, ""); };
var cleanImageUrl = function (str) { return str && str.includes("imgix") && str; };
var showAd = function (index) { return index > 0 && index % 10 === 0; };
var SearchResults = function (_a) {
    var results = _a.results, onScroll = _a.onScroll;
    return (React.createElement("div", null, results.length && (React.createElement("div", null,
        results.map(function (result, index) {
            var description = result.highlights.body || removeHTML(result.body) || "";
            var descriptionPipe = description.indexOf("|");
            var descriptionShort = description.substr(descriptionPipe + 1, descriptionPipe + 251);
            return (React.createElement(React.Fragment, null,
                showAd(index) && (React.createElement("div", { className: styles.adSearchResult },
                    React.createElement(AdLabel, null, "Advertisement"),
                    React.createElement(GPT, { adUnitPath: adUnits.searchInContent, sizeMapping: [
                            {
                                slot: [adMobileRectangle, adMobileSquare, adSuperzone],
                                viewport: [0, 0],
                            },
                            {
                                slot: [adBannerSmall, adSuperzone],
                                viewport: [1390, 0],
                            },
                        ], targeting: generateAdTargeting({
                            position: adPositions.inContent,
                        }) }))),
                React.createElement(ListItem, { className: styles.listItem, key: result.title + "-" + result.id, subtype: result.subtype, category: getResultCategory(result), categoryLink: result.url, description: descriptionShort, link: result.url, thumbnail: cleanImageUrl(result.thumbnail || result.image), title: cleanTitle(result.title), type: result.opType })));
        }),
        React.createElement(Waypoint, { onEnter: onScroll })))));
};
SearchResults.propTypes = {
    onScroll: PropTypes.func,
    results: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string,
        thumbnail: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
        url: PropTypes.string,
    })),
};
export { SearchResults };



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/searchResults/index.tsx
// module id = wdAr
// module chunks = 2